import { FieldNames } from '../model/form-fields.model';
import { FieldOption } from '../model/form.model';
import { API_STATUS, ApiEnvNames, ApiPayload, ApiResponse, fieldOptionsSearchConfig, SearchConfig } from '../model/api.model';
import { lastValueFrom } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { CommonUtils } from '../utils/common.utils';
import { ApiService } from './api/api.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalApiService {
  private readonly commonUtils = inject(CommonUtils);
  private readonly apiService = inject(ApiService);

  readonly options: Record<string, FieldOption[]> = {};

  getDataFromDataSource(apiPayLoad: ApiPayload): Promise<ApiResponse> {
    return lastValueFrom(this.apiService.fetchAllData(apiPayLoad))
  }
  getOptionsForField(fieldName: string): Promise<any> {
    let options: Promise<any>;
    if (fieldName === FieldNames['CourseShortName']) {
      const backendColumnMapping = { fieldLabel: 'shortName', fieldValue: 'shortName' };
      options = this.fetchOptions(fieldOptionsSearchConfig[fieldName], backendColumnMapping, "dealerTrainingBilling");
    } else if (fieldName === FieldNames['DealerNumber']) {
      const backendColumnMapping = { fieldLabel: 'organisation', fieldValue: 'organisation' };
      options = this.fetchOptions(fieldOptionsSearchConfig[fieldName], backendColumnMapping, "dealerTrainingBilling");
    } else if (fieldName === FieldNames['CourseNameCode']) {
      const backendColumnMapping = { fieldLabel: 'title', fieldValue: 'title' };
      options = this.fetchOptions(fieldOptionsSearchConfig[fieldName], backendColumnMapping, "dealerTrainingBilling");
    } else if (fieldName === FieldNames['TenureAreaRegion']){
      const backendColumnMapping = { fieldLabel: 'label', fieldValue: 'value' };
      options = this.fetchOptions(fieldOptionsSearchConfig[fieldName], backendColumnMapping, ApiEnvNames['Tenure']);
    } 
    else {
      options = Promise.resolve([]);
    }
    options.then((option: Array<any>) => {
      this.options[fieldName] = option;
    })
    return options
  }
  async fetchOptions(fetchConfig: SearchConfig, field: FieldOption, optionsUrlKey: string): Promise<{ fieldLabel: string, fieldValue: string }[]> {
    const handleError = () => {
      const errorMsg = `Error fetching options, please try after sometime`;
      this.commonUtils.showMatSnackBar(errorMsg);
      return Promise.resolve([]);
    };

const env = (globalThis as any).environment;
    if (!env?.[optionsUrlKey]) {
      return handleError();
    }
    const url = env[optionsUrlKey] + fetchConfig['path']
    const payload: ApiPayload = {
      ...fetchConfig,
      url: url
    }

    try {
      const response = await lastValueFrom(this.apiService.fetchAllData(payload));

      if (response.status === API_STATUS.Success) {
        const result = response.result;

        return this.mapFieldValuesForDropDowns(result, field);
      } else {
        return handleError();
      }
    } catch (error) { 
      return handleError();
    }
  }

  mapFieldValuesForDropDowns = (arr: any, field: FieldOption) => {
    const labelKey = field.fieldLabel || 'label';
    const valueKey = field.fieldValue || 'value';
    return arr.map((item: any) => ({
      fieldLabel: item[labelKey],
      fieldValue: item[valueKey]
    }));
  }
}